import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<rect x="4" y="16" width="13" height="7" rx="1"/><rect x="23" y="11" width="2" height="19" rx="1"/><path d="M29.38 10.91a7 7 0 00-1.86-2.31A5 5 0 0028 6.5 4.27 4.27 0 0024 2a3.92 3.92 0 00-3.32 2 5 5 0 00-.41 4.12 4.4 4.4 0 00.21.5A6.41 6.41 0 0018 13.7a6.22 6.22 0 005 6.21V12a1 1 0 012 0v7.91a6.22 6.22 0 005-6.21 6.12 6.12 0 00-.62-2.79zM18 25H3a1 1 0 000 2h1v2a1 1 0 002 0v-2h9v2a1 1 0 002 0v-2h1a1 1 0 000-2z"/>';
export var NeighborhoodSVG = function NeighborhoodSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
NeighborhoodSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(NeighborhoodSVG);